import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import TransactionalMessageModel from 'cio/models/transactional-message';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class TransactionalMessage extends Route {
  @service store!: DS.Store;

  crumb() {
    let model = this.modelFor(this.routeName) as TransactionalMessageModel;

    return {
      name: model.name,
      path: this.routeName,
    };
  }

  model(params: { transactional_message_id: string }) {
    return this.store.findRecord('transactional-message', params.transactional_message_id);
  }

  redirect(model: TransactionalMessageModel, transition: Transition) {
    // Redirect to the overview or setup route based on the state of the
    // message unless the transition is already to that route.
    if (model.isActive || model.isDefault) {
      if (transition.to?.name.includes('transactional.message.overview')) {
        return;
      }

      this.router.transitionTo('transactional.message.overview');
    } else {
      if (transition.to?.name.includes('transactional.message.setup')) {
        return;
      }

      this.router.transitionTo('transactional.message.setup');
    }
  }
}
